import React from "react";
import { ITEM_HORIZONTAL_SPACING } from "../../styles/spacing";

type ItemHorizontalSpaceProps = {};

export const ItemHorizontalSpace = (props: ItemHorizontalSpaceProps) => {
  return <div style={{ width: ITEM_HORIZONTAL_SPACING }} />;
};
